import React from 'react';
import { makeStyles, mergeClasses } from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
  },
});

export const SizesView = () => {
  const classes = useStyles();
  return (
    <div className={mergeClasses('sizes', classes.container)}>
      sizes
    </div>
  );
};
